export const InviteModes = {
  REQUEST: 'request',
  IMMEDIATE: 'immediate',
};
